<template>
  <v-card class="home-card py-0 px-0 rounded-lg v-card v-sheet theme--light elevation-0" elevation="0">
    <v-card-text>
      <div class="d-flex">
        <div class="flex mr-3">
          <div>
            <p class="pb-0 mb-0 text-card">
              Procurando pelo e-commerce?<br />
              Acesse a plataforma do <strong class="color-strong">Mercashop</strong>
            </p>
          </div>
        </div>
        <div class="flex">
          <div>
            <mf-button icon-position="right" label="Acessar" color="marca-1-d10" icon="arrow_forward" @click="goToEcommerce"></mf-button>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  methods: {
    goToEcommerce() {
      location.href = `${this.$getLoggedUser().ecommerce_url}/admin/`
    },
  },
}
</script>

<style scoped lang="scss">
.home-card {
  border-radius: 8px !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16) !important;
  height: 100%;
  .button-rounded {
    border-radius: 8px;
  }
  .color-strong {
    color: $marca-1-d10;
  }
  .text-card {
    color: $marca-0-l10;
    line-height: 120%;
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
